const hasMenuAccess = (menu, can) => {
  if (!menu?.abilities) {
    return true;
  }

  const hasAbility = ({ action = 'read', subject, field }) => (
    can(action, subject, field)
  );

  if (menu.abilityMode === 'any') {
    return menu.abilities.some(hasAbility);
  }

  return menu.abilities.every(hasAbility);
};

export default hasMenuAccess;
